var compNavLocation = function () { };

/* start order link fix Begins*/
function startOrderLink() {
    let storeId = null;
    let storeCountry = orderViewModel.store.storeCountry ? orderViewModel.store.storeCountry.toLowerCase() : '';
    const cookiedata = getCookieByCountry()
    if (!orderViewModel.store || (byUrlCulture() != storeCountry) && (getCookieByCountry() && getCookieByCountry().LocationId)) {
        orderViewModel.store.id = subwayScript.checkSatelliteNumber(cookiedata.LocationId.StoreNumber);
        orderViewModel.store.storeCountry = cookiedata.LocationId.Country;
        orderViewModel.save()
        storeId = orderViewModel.store.id;
    }
    else if (byUrlCulture() == storeCountry) {
        storeId = orderViewModel.store.id ? orderViewModel.store.id : cookiedata && subwayScript.checkSatelliteNumber(cookiedata.LocationId.StoreNumber);
    }
    else {
        orderViewModel.store.id = null;
        orderViewModel.save();
    }
    let itemsInCartCount = orderViewModel.currentOrder.cartQuantity;
    let orderType = orderViewModel.orderType;
    orderViewModel.selectedStoreId = storeId;
    orderViewModel.save();

    const selectedLang = $("#scLanguageCode").val().toLowerCase()
    if (selectedLang.includes('pr')) {
        const lang = selectedLang.split('-')[0].toLowerCase();
        if (lang == 'es') {
            orderViewModel.store.languageCode = 'esp';
        } else {
            orderViewModel.store.languageCode = 'eng';
        }
        orderViewModel.save();
    }

    if (itemsInCartCount != null && itemsInCartCount > 0) {
        $("button.start_order").addClass("hide");
    } else if (storeId && orderViewModel.storeStatus) {
        $("button.start_order").removeClass("hide");
        $("button.start_order").attr('onclick', "engageApptentiveEvent('Start Order',true,'" + subwayScript.navigation.getMenuUrl(storeId) + "', '', event);sendClickInfoToAnalyticsCMS('header', 'default', 'Start Order', 'start order', '', '', event)");
    } else if (!orderViewModel.storeStatus && orderViewModel.calledCreateCart) {
        $("button.start_order").on('click', () => (modalShowId('#modal-store-closed')));
    } else {
        $("button.start_order").removeClass("hide");
    }
}
/* start order link fix Ends*/

function rewardsAndDeals() {
    targetURL = orderViewModel.hasLoggedIn ? subwayScript.navigation.getDealsPageUrl() : '';
    if (targetURL) {
        $('.navbar_menu_items .deals').attr("href", targetURL);
    }
}

$(function () {
    if ($(".hide-spinner").length > 0) {
        subwayScript.hideSpinner();
    }

    if ($("#MakeAMeal").length) {
        $(".footer-containerbox").hide();
    }

    if ($(".errorbody").length) {
        $(".errorbody").load(function () {
            $(".errorbody").hide();
        });
    }
});
$(document).ready(function () {
    orderViewModel.headerFooterLanguageCode = $("html").attr("lang")
    orderViewModel.save()
    $(".find-locator").show();
    let data = cacheData();
    if ((orderViewModel.currentOrder.cartQuantity > 0) || (data && data.cart > 0)) {
        // var itemInCartQty === (orderViewModel.currentOrder.cartQuantity || (data && data.cart));
        loadCartBag();
    }
    if (data && data.isLoggedIn) {
        $("#stick-to").removeClass("isLoggedOut");
        $("#stick-to").addClass("isLoggedIn");
    }
    else {
        $("#stick-to").removeClass("isLoggedIn");
        $("#stick-to").addClass("isLoggedOut");
    }

    /*setUserProfileImage();*/
    const existingStoreData = getCookieByCountry();
    if (existingStoreData && !orderViewModel.store.id) {
        orderViewModel.orderType = existingStoreData.LocationId.Ordertype;
        orderViewModel.save();
        compStoreLocator.Init(null, existingStoreData);
    }
    startOrderLink();
    rewardsAndDeals();
    defaultStoreHeader();
});

function defaultStoreHeader() {
    if ((orderViewModel.store && orderViewModel.store.id) || (getCookieByCountry() && !orderViewModel.storeStatus)) {
        let addressTxt = '';
        if (!orderViewModel.hasLoggedIn && getCookieByCountry()) {
            addressTxt = getCookieByCountry().LocationId.Address;
        }
        else {
            addressTxt = orderViewModel.store && orderViewModel.store.address1;
        }
        if ($('#defaultStoreHeader').length) {
            $('#defaultStoreHeader').removeClass('d-none')
            if (orderViewModel.orderType == 'delivery') {
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-24-px-delivery@3x.PNG")
                $('#defaultStoreHeader span').text($('#deliveryToText').val());
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getDeliveryLocatorUrl())
                $('#defaultStoreHeader a').text(orderViewModel.DeliveryAddress.StreetAddressLine1)
            } else {
                if (orderViewModel.orderType === 'curbside') {
                    $('#defaultStoreHeader span').text($('#curbsidepickupText').val())
                } else {
                    $('#defaultStoreHeader span').text($('#pickupOnlyText').val())
                }
                $('#defaultStoreHeader a').attr('href', subwayScript.navigation.getLocatorUrl())
                //TODO Leagacy code need to remove old BAU Code
                $('#defaultStoreHeader img').attr('src', "/Assets/RemoteOrder/img/05-ui-icon-pickup@3x.png")
                $('#defaultStoreHeader a').text(addressTxt);
            }
        }
    }
}

//function setUserProfileImage() {
//    let cacheValue = ('; ' + document.cookie).split(`; UserProfileCacheKey=`).pop().split(';')[0];
//    let cacheJsonResult = JSON.parse(cacheValue);
//    if (orderViewModel.hasLoggedIn || cacheJsonResult.isLoggedIn) {
//        $('#desktop-transactionalHeader account_loggedIn').show()
//        $('#globalHeader account_loggedIn').show()
//        $('#desktop-transactionalHeader account_logged').hide()
//        $('#globalHeader account_logged').hide()
//    } else {
//        $('#desktop-transactionalHeader account_loggedIn').hide()
//        $('#globalHeader account_loggedIn').hide()
//        $('#desktop-transactionalHeader account_logged').show()
//        $('#globalHeader account_logged').show()
//    }
//}
function cacheData() {
    let cacheValue = ('; ' + document.cookie).split(`; UserProfileCacheKey=`).pop().split(';')[0];
    if (cacheValue) {
        return JSON.parse(cacheValue);
    }
    else {
        return;
    }
}
function loadCartBag() {
    let data = cacheData();
    var itemsInCart = orderViewModel && orderViewModel.currentOrder && orderViewModel.currentOrder.cartQuantity;
    if (orderViewModel && orderViewModel.currentOrder && orderViewModel.currentOrder.cartQuantity) {
        itemsInCart = orderViewModel.currentOrder.cartQuantity;
    }
    else {
        itemsInCart = data && data.cart;
    }
    if ($(".cart_bag.full .totalCartQuantity").length === 0 && $('.bag-quantity').length === 0) {
        $(".cart_bag.full").append(`<div class="view_bag"></div>`);
        $(".cart_bag.full").append(`<div class="badge-bagcount totalCartQuantity"></div>`);
    }
    let viewBagText = $('.cart_bag.full').attr("data-viewbag");
    $('.view_bag').html(viewBagText);
    var $bagBadge = $(".badge-bagcount");

    const cartCount = localStorage.getItem('cartProgressBar');

    if (cartCount && $(".progressBarStyle").length === 0 && window.location.pathname.indexOf('/menu') === -1) {
        localStorage.removeItem('cartProgressBar');
        $(".navbar.cms").append('<div class="textWrapper"></div>');
        $(".textWrapper").append('<div class="textStyle" role="alert" aria-live="polite"></div>');
        $(".textWrapper").append('<img class="fullCartIcon" />');
        $(".navbar.cms").append('<div class="progressBarStyle"></div>');
        $(".progressBarStyle").append('<div class="progressFillStyle"></div>');
        
        let addToBagText = $('.cart_bag.full').attr("data-addtobag");
        $('.textStyle').html(addToBagText);
        let cartFullIcon = $('.cart_bag.full img').attr('src');
        $('.fullCartIcon').attr('src', cartFullIcon);
        analytics.bannerNotificationAnalytics(addToBagText);
    
        setTimeout(function () {
            $('.textWrapper, .progressBarStyle').remove();
        }, 5000);
    }

    if (!itemsInCart) {
        $(".emptybagImage").show();
        $(".cart_bag.empty").show();
        orderViewModel.currentOrder.animationForCartQty = false;
        orderViewModel.save();
        $(".fullBagImage").hide();
        $(".cart_bag.full").hide();
        $(".cart_bag.animation").hide();
        $(".totalCartQuantity").hide();
        $bagBadge.hide();
    } else {
        $(".emptybagImage").hide();
        setTimeout(function () {
            $(".cart_bag.empty").hide();
        }, 3000);
        $("body").removeClass("fullCart");
        if ($bagBadge.first().text() == '' && !orderViewModel.currentOrder.animationForCartQty) {
            $(".fullBagImageAnimation").removeClass('hideAnimation');
            $(".cart_bag.animation").show();
            $(".cart_bag.animation").css({ "margin-bottom": "7px" })
            $(".fullBagImage").hide();
            $(".cart_bag.full").hide();
            $(".totalCartQuantity").show().html(itemsInCart);
            orderViewModel.currentOrder.animationForCartQty = true;
            orderViewModel.save();
            $bagBadge.text(itemsInCart);
            setTimeout(function () {
                $(".fullBagImageAnimation").hide();
                $(".cart_bag.animation").hide();
                $(".fullBagImage").show();
                $("body").addClass("fullCart");
                $(".cart_bag.full").show();
                $("button.start_order").addClass("hide");
                $(".totalCartQuantity").show().html(itemsInCart);
                $bagBadge.text(itemsInCart);
            }, 2000)
        } else {
            $(".fullBagImageAnimation").hide();
            $(".cart_bag.animation").hide();
            $(".fullBagImage").show();
            $("body").addClass("fullCart");
            const ariaLabel = $(".cart_bag.full:eq(0)").attr("aria-Label");
            $(".cart_bag.full").attr('aria-label', itemsInCart + ' ' + ariaLabel);
            let ariaLabelValue = ariaLabel ? ariaLabel.split(' ') : '';
            if (ariaLabel && ariaLabel.split(' ').length > 2) {
                if ($.isNumeric(ariaLabelValue[0])) {
                    $(".cart_bag.full").attr('aria-label', $(".cart_bag.full:eq(0)").attr("aria-Label").slice(2));
                }
            }
            $(".cart_bag.full").show();
            $("button.start_order").addClass("hide");
            $(".totalCartQuantity").show().html(itemsInCart);
            $bagBadge.text(itemsInCart);
        }
    }
    setCookie();
}

// for storing value in cache we commented it no need of set timeout(causing issue)
//(function () {
//    return setInterval(() => {
//        if (
//            orderViewModel.currentOrder.cartQuantity > 0 &&
//            itemInCartQty !== orderViewModel.currentOrder.cartQuantity
//        ) {
//            itemInCartQty === orderViewModel.currentOrder.cartQuantity;
//            loadCartBag();
//        }
//    }, 2000);
//})();

compNavLocation.Bind = function () {
    if (orderViewModel.store.id != null) {
        $("#locator-text").html(orderViewModel.store.address1);
        $(".store-address3").html(orderViewModel.store.address3);
        $(".city").html(orderViewModel.store.city);
        $(".state").html(orderViewModel.store.stateProvCode);
        $(".zip").html(orderViewModel.store.postalCode);
        $(".telephone-no").html(orderViewModel.store.phoneNumber);
        $(".location-bar").show();
        $(".telephone-container .telephone").attr(
            "href",
            "tel:" + orderViewModel.store.phoneNumber
        );
        var bannerHeight = $(".banner-img img").height() - 68;
        $(".banner-text-container,.banner-table").css({ height: bannerHeight });
        $(".banner-text-container").css({ "margin-top": -bannerHeight });

        if (
            $("#contextId").val() == orderViewModel.ScPage.orderManagement &&
            $(window).width() < 1024
        ) {
            if ($("#empty-bag").is(":visible")) {
                $(".location-bar").show();
            } else {
                $(".location-bar").hide();
            }
        }
        if ($("#contextId").val() == orderViewModel.ScPage.orderConfirmation) {
            $(".location-bar").hide();
        }

        var itemsInCartCount = orderViewModel.currentOrder.cartQuantity;
        if (itemsInCartCount != null && itemsInCartCount > 0) {
            var lnkText = $(".start-order-btn").data("continue-order-text");
            $(".start-order-btn").html(lnkText);
            $(".start-order-btn").prop("title", lnkText);
        }
    } else {
        var bannerHeight = $(".banner-img img").height() + 7;
        $(".banner-text-container,.banner-table").css({ height: bannerHeight });
        $(".banner-text-container").css({ "margin-top": -bannerHeight });
    }
    var itemsInCart = orderViewModel.currentOrder.cartQuantity;
    let data = cacheData();
    if (orderViewModel.currentOrder.cartQuantity) {
        itemsInCart = orderViewModel.currentOrder.cartQuantity;
    }
    else {
        itemsInCart = data && data.cart;
    }
    loadCartBag();
    if (!itemsInCart) {
        $(".icon-shopping-cart").removeAttr("aria-describedby");
    } else if (parseInt(itemsInCart) === 1) {
        $(".itemText").text("item");
    } else {
        $(".itemText").text("items");
    }
    setCookie();

    orderViewModel.scLanguageCode = $("html").attr("lang").split("-").pop();
    orderViewModel.isLangChanged = false;
    orderViewModel.save();
    //only apply sticky classes when at a mobile breakpoint
    if ($(window).width() < 1024) {
        if ($(".banner-tile").length > 0) {
            $("header").addClass("sticky");
        } else {
            $(".navbar-main").addClass("sticky");
        }
        $(".navbar").last().addClass("nav-shadow");
        $(".icon-link").attr({ tabindex: "0", "aria-hidden": "false" });

        if ($(".green-backdrop .green-backdrop-fine-print").html() != "") {
            $(".green-backdrop .green-backdrop-fine-print").css("margin-top", "18px");
        }

        if ($(".change-language-banner").is(":visible")) {
            $(".location-bar .store-address .icon-expand_more").css({ top: "129px" });
            $(".location-bar").next(".expanded-content").css({ top: "173px" });
            $("#deliveryDropdown .delivery-address .icon-expand_more").css({
                top: "129px",
            });
            $("#deliveryDropdown").next(".expanded-content").css({ top: "173px" });
        }
    } else {
        $(".navbar-main").removeClass("sticky");
        $("header").removeClass("sticky");
        if ($(".banner-table .fine-print").html() != "") {
            $(".banner-table .fine-print").css("margin-top", "20px");
        }
        if ($(".change-language-banner").is(":visible")) {
            $(".location-bar").next(".expanded-content").css({ top: "221px" });
            $("#deliveryDropdown").next(".expanded-content").css({ top: "221px" });
        }
    }

    if ($(".banner-tile").length > 0) {
        $(".location-bar").addClass("location-bar-overlay");
        $(".location-bar .expanded-content").css({ top: "57px", opacity: "unset" });
        $(".navbar-locater .start-order-btn").show();
    } else {
        $(".location-bar").removeClass("location-bar-overlay");
        $(".navbar-locater .start-order-btn").hide();
    }

    $(".sticky").length > 0 && $(".sticky").stick_in_parent({ parent: "#stick-to", bottoming: false });
    var navHeight = $(".navbar-locater").height();
    $(".sticky").length > 0 && $(".sticky2").stick_in_parent({
        offset_top: navHeight,
        parent: "#stick-to",
        bottoming: false,
    });

    var resizeTimer;

    $(window).resize(function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // applies generically to all items with sticky class

            hideLanguageFromDropdown();

            if ($(window).width() < 1024) {
                if ($(".banner-tile").length > 0) {
                    $("header").addClass("sticky");
                } else {
                    $(".navbar-main").addClass("sticky");
                }
                if ($("#ftue-modal, .modal-overlay").attr("aria-hidden") == "false") {
                    if (!$(".modal-overlay").find(".overlayModal").length) {
                        $("html").css("overflow-y", "hidden");
                    }
                }
                $(".sticky").length > 0 && $(".sticky").stick_in_parent({ parent: "#stick-to", bottoming: false });
                $(".sticky2").length > 0 && $(".sticky2").trigger("sticky_kit:detach");
                navHeight = $(".navbar-locater").height();
                $(".sticky2").length > 0 && $(".sticky2").stick_in_parent({
                    offset_top: navHeight,
                    parent: "#stick-to",
                    bottoming: false,
                });
                $(".navbar").last().addClass("nav-shadow");
                //ADA Compliance attributes
                $(".icon-link").attr({ tabindex: "0", "aria-hidden": "false" });
                if ($(".green-backdrop .green-backdrop-fine-print").html() != "") {
                    $(".green-backdrop .green-backdrop-fine-print").css(
                        "margin-top",
                        "18px"
                    );
                }
                if ($(".change-language-banner").is(":visible")) {
                    $(".location-bar .store-address .icon-expand_more").css({
                        top: "129px",
                    });
                    $(".location-bar").next(".expanded-content").css({ top: "173px" });
                    $("#deliveryDropdown .delivery-address .icon-expand_more").css({
                        top: "129px",
                    });
                    $("#deliveryDropdown")
                        .next(".expanded-content")
                        .css({ top: "173px" });
                }
            } else {
                $(".sticky").trigger("sticky_kit:detach");
                $(".sticky2").trigger("sticky_kit:detach");
                $(".navbar").last().removeClass("nav-shadow");
                //ADA Compliance attributes
                $(".icon-link").attr("tabindex", "-1");
                if ($(".banner-table .fine-print").html() != "") {
                    $(".banner-table .fine-print").css("margin-top", "20px");
                }
                if ($(".change-language-banner").is(":visible")) {
                    $(".location-bar").next(".expanded-content").css({ top: "221px" });
                    $("#deliveryDropdown")
                        .next(".expanded-content")
                        .css({ top: "221px" });
                }
            }

            if ($(window).width() > 1023) {
                $("#overlayNav").hide();
                $("#overlayNav").removeClass("overlay-mobile");
                if ($(".hamburger").hasClass("change")) {
                    $(".hamburger").toggleClass("change");
                    $(".mobile-header .navbar-locator-component").toggleClass(
                        "hide-cart-icon"
                    );
                    $(".navbar-locater.display-mobile").toggleClass("hide-box-shadow");
                }
                $("body").css("overflow-y", "initial");
                $("html").css("overflow-y", "initial");
            }

            if (
                orderViewModel.store.id != null &&
                orderViewModel.ScContext.id == orderViewModel.ScPage.orderManagement &&
                $(window).width() < 1024
            ) {
                if ($("#empty-bag").is(":visible")) {
                    $(".location-bar").show();
                } else {
                    $(".location-bar").hide();
                }
            } else if (orderViewModel.store.id != null) {
                $(".location-bar").show();
            }
            if ($("#contextId").val() == orderViewModel.ScPage.orderConfirmation) {
                $(".location-bar").hide();
            }

            if (orderViewModel.store.id != null) {
                var bannerHeight = $(".banner-img img").height() - 68;
                $(".banner-text-container,.banner-table").css({ height: bannerHeight });
                $(".banner-text-container").css({ "margin-top": -bannerHeight });
            } else {
                var bannerHeight = $(".banner-img img").height();
                var top = bannerHeight + 7;
                $(".banner-text-container,.banner-table").css({ height: bannerHeight });
                $(".banner-text-container").css({ "margin-top": -top });
            }
        }, 500);
    });
};
compNavLocation.updateCartBag = function () {
    var itemsInCart = orderViewModel.currentOrder.cartQuantity;
    var $bagBadge = $(".badge-bagcount");
    if (!itemsInCart) {
        $bagBadge.hide();
    } else {
        $bagBadge.text(itemsInCart);
    }
    if (!itemsInCart) {
        $(".icon-shopping-cart").removeAttr("aria-describedby");
    } else if (parseInt(itemsInCart) === 1) {
        $(".itemText").text("item");
    } else {
        $(".itemText").text("items");
    }
};

//ToDo remove this function
function globalHeader(resultData) {
    var items = [];
    var listItems = [];
    var listItemsMobile = [];
    items = resultData.Data;
    if (items != null) {
        items = resultData.Data[0].links;
        $.each(items, function (key, val) {
            if (val != null) {
                var res = val.title.replace(/\r/g, " ");
                var targetURL = val.href;
                var targetWindow = "_blank";
                var sourceName = "header:";
                if (
                    val.title == "Find a Subway" ||
                    val.title == "Trouver un restaurant Subway" ||
                    val.title == "Trouver Un Subway"
                ) {
                    targetURL = val.override
                        ? subwayScript.navigation.getLocatorUrl()
                        : targetURL;
                    targetWindow = "_self";
                }

                if (
                    val.title == "Rewards & Deals" ||
                    val.title == "Récompenses et offres"
                ) {
                    targetURL = orderViewModel.hasLoggedIn
                        ? subwayScript.navigation.getDealsPageUrl()
                        : targetURL;
                    //$('.navbar_menu_items .deals').attr("href", targetURL);
                    targetWindow = orderViewModel.hasLoggedIn ? "_self" : "_blank";
                }

                listItems += `<li><span class="nav-items"><a target=${targetWindow} href= ${targetURL} onclick="sendClickInfoToAnalytics('${val.title}', '${sourceName}')">${res}</a></span></li>`;
                listItemsMobile.push(
                    $(
                        '<div class="menu-item"><a href="' +
                        targetURL +
                        '"target="' +
                        val.target +
                        '"title= "' +
                        res +
                        '" class="mobileMenu"" onclick="sendClickInfoToAnalytics(\'' +
                        val.title +
                        "', '" +
                        sourceName +
                        '\')"><span aria-hidden="true">' +
                        res +
                        '</span> <b class="pull-right"></b></a></div>'
                    )
                );
            }
        });
        $("#globalHeaderNew").empty().append(listItems);
        $("#globalHeaderMobile").empty().append(listItemsMobile);
    }
}

function globalFooter(resultData) {
    subwayScript.showSpinner();
    var items = [];
    var itemsTitle;
    var itemsId;
    var elements = "";
    var grid;
    var subwayRegisterTradeMark = "";
    var bottom = "";
    var baseURL;
    items = resultData.Data;
    baseURL = $("#hdnImageBaseUrl").val();
    if (items != null) {
        items = resultData.Data;
        var filtered_fourthcol_partnerLinks = items.filter((x) =>
            x.id.includes("partners")
        );
        var filtered_fourthcol_countyLinks = items.filter((x) =>
            x.id.includes("country")
        );
        var filtered_fourthcol_sociallinks = items.filter((x) =>
            x.id.includes("social")
        );
        subwayRegisterTradeMark = items.filter((x) =>
            x.id.includes("subway-registered-trademark")
        );
        bottom = items.filter((x) => x.id.includes("bottom"));
        var filtered_footerlinks_updated = filtered_fourthcol_partnerLinks;
        filtered_footerlinks_updated = filtered_footerlinks_updated.concat(
            filtered_fourthcol_countyLinks
        );
        filtered_footerlinks_updated = filtered_footerlinks_updated.concat(
            filtered_fourthcol_sociallinks
        );
        var builtTempArray = [];
        $.each(filtered_footerlinks_updated, function (key, val) {
            builtTempArray.push(val);
        });

        if (items !== null) {
            var footerLinks1;
            var footerLinks2;
            var footerLinks2_mobile;
            var social = "";
            var feed = "";
            var country = "";
            $.each(items, function (key, val) {
                if (val !== null) {
                    var result = [];
                    var strTitle = "";
                    itemsId = val.id;
                    var count = val.links.length;
                    itemsTitle = "";
                    str = "";
                    var sourceName = "footer:";
                    if (itemsId == "footer-links-1" || itemsId == "footer-links-2") {
                        itemsTitle = items[key].text;
                        strTitle = `<div class="footer-title  globalFooterTheBoss" >${itemsTitle}</div>`;
                    }

                    if (itemsId == "footer-links-1") {
                        footerLinks1 = "";
                        let itemsToSplit = items[key].links.slice();

                        const n = Math.round(items[key].links.length / 2);
                        result = new Array(Math.ceil(itemsToSplit.length / n))
                            .fill()
                            .map((_) => itemsToSplit.splice(0, n));
                        if (count > 7) {
                            grid = (12 / result.length).toFixed(0);
                        } else {
                            grid = "12";
                        }
                        $.each(result, function (index, linkSorted) {
                            footerLinks1 += `<div class="card-col col-md-${grid} col-lg-${grid}  col-sm-${grid} col-xs-${grid} padzero"><ul class="options">`;
                            $.each(linkSorted, function (index, links) {
                                var res = links.title.replace(/\r/g, " ");
                                footerLinks1 += `<li class="card-col footer-link-text itemfont padzero"><a href="${links.href}" target="_blank" onclick="sendClickInfoToAnalytics('${links.title}', '${sourceName}')" >${res}</a></span></li>`;
                            });
                            footerLinks1 += `</ul ></div>`;
                        });

                        footerLinks1 = `<div class="footer-colu card-col col-md-12 col-lg-12  col-sm-12 col-xs-12 padzero">${strTitle} ${footerLinks1}</div>`;
                    } else if (itemsId == "footer-links-2") {
                        let itemsToSplit = items[key].links.slice();

                        const n = 8;
                        result = new Array(Math.ceil(itemsToSplit.length / n))
                            .fill()
                            .map((_) => itemsToSplit.splice(0, n));
                        if (count > 7) {
                            grid = (12 / result.length).toFixed(0);
                        } else {
                            grid = "12";
                        }
                        footerLinks2 = "";
                        footerLinks2_mobile = "";
                        $.each(result, function (index, linkSorted) {
                            footerLinks2 += `<div class="card-col col-md-${grid} col-lg-${grid}  col-sm-${grid} col-xs-${grid} padzero sun1"><ul class="options">`;
                            $.each(linkSorted, function (index, links) {
                                var res = links.title.replace(/\r/g, " ");
                                footerLinks2 += `<li class="card-col footer-link-text itemfont padzero"><a href="${links.href}" target="_blank" onclick="sendClickInfoToAnalytics('${links.title}', '${sourceName}')">${res}</a></span></li>`;
                            });
                            footerLinks2 += `</ul ></div>`;
                        });

                        footerLinks2 = `<div class="footer-colu card-col col-md-12 col-lg-12  col-sm-12 col-xs-12 hide-mobile-footer padzero">${strTitle} ${footerLinks2}</div>`;

                        //Mobile
                        const nMob = 4;
                        let itemsToSplit_mob = items[key].links.slice();
                        result = new Array(Math.ceil(itemsToSplit_mob.length / nMob))
                            .fill()
                            .map((_) => itemsToSplit_mob.splice(0, nMob));
                        if (count >= 7) {
                            grid_mob = (12 / result.length).toFixed(0);
                        } else {
                            grid_mob = "12";
                        }
                        $.each(result, function (index, linkSorted) {
                            footerLinks2_mobile += `<div class="card-col col-md-${grid_mob} col-lg-${grid_mob}  col-sm-${grid_mob} col-xs-${grid_mob} padzero"><ul class="options">`;
                            $.each(linkSorted, function (index, links) {
                                var res = links.title.replace(/\r/g, " ");
                                footerLinks2_mobile += `<li class="card-col footer-link-text itemfont padzero"><a href="${links.href}" target="_blank" onclick="sendClickInfoToAnalytics('${links.title}', '${sourceName}')"> ${res}</a></span></li>`;
                            });
                            footerLinks2_mobile += `</ul ></div>`;
                        });
                        footerLinks2 += `<div class="footer-colu card-col col-md-12 col-lg-12  col-sm-12 col-xs-12 display-mobile-footer padzero">${strTitle} ${footerLinks2_mobile}</div>`;
                    } else if (itemsId == "partners" || "country" || "social") {
                        var marginClass = "";
                        var marginSocial = "";
                        var marginClassTop = "";
                        var img = "";
                        var res = "";
                        var footerLink3 = "";

                        grid = "12";

                        if (itemsId == "country") {
                            marginClass = "country";
                            marginClassTop = "marginTop10";
                        } else if (itemsId == "social") {
                            marginClass = "social";
                            marginSocial = "footer__connect-item";
                            imgClass = "country";
                        } else if (itemsId == "partners") {
                            marginClass = "partners";
                            marginSocial = "partnersDiv";
                        }
                        result = items[key].links;
                        footerLink3 += `<ul class="options">`;
                        $.each(result, function (index, links) {
                            if (itemsId !== "social") {
                                res = links.text.replace(/\r/g, " ");
                            }
                            img = "";
                            $.each(links.image, function (index, socialImage) {
                                var src;
                                if (
                                    socialImage.desktop !== undefined &&
                                    socialImage.desktop !== ""
                                ) {
                                    src = baseURL + socialImage.desktop.src;
                                    img += `<img class="hide-mobile-footer" src=${src} alt=${socialImage.desktop.alt} />`;
                                } else if (
                                    socialImage.mobile !== undefined &&
                                    socialImage.mobile !== ""
                                ) {
                                    src = baseURL + socialImage.mobile.src;
                                    img += `<img class="display-mobile-footer" src=${src} alt=${socialImage.mobile.alt} />`;
                                }
                            });
                            // }

                            footerLink3 += `<li class="card-col footer-link-text itemfont  ${marginSocial} ${marginClassTop}"><a href="${links.href}" target="_blank" class="${marginClass}" onclick="sendClickInfoToAnalytics('${res}', '${sourceName}')">${img}  ${res}</a></span></li>`;
                        });
                        footerLink3 += `</ul >`;

                        if (itemsId == "partners") {
                            feed = footerLink3;
                        } else if (itemsId == "country") {
                            country = footerLink3;
                        } else if (itemsId == "social") {
                            social = footerLink3;
                        }
                    }
                }
            });

            $("#footer-links1").empty().append(footerLinks1);
            $("#footer-links2").empty().append(footerLinks2);
            $("#feed").empty().append(feed);
            $("#country").empty().append(country);
            $("#social").empty().append(social);

            var bottom_links = "";
            bottom_links += `<div class="card-col col-md-9 col-lg-12  col-sm-12 col-xs-12 footerpane_bottom"><ul class="options footerpane_utility">`;
            if (bottom !== null) {
                $.each(bottom[0].links, function (index, links) {
                    var res = links.title.replace(/\r/g, " ");
                    if (
                        links.title.toLowerCase() === "cookie settings" ||
                        links.title.toLowerCase() === "paramètres des cookies"
                    ) {
                        bottom_links += `<li class="card-col footerpane_utility-item footer-link-text itemfont padzero"><a href="javascript:void(0)" class="optanon-toggle-display footer-link-text" > ${links.text} </a></span></li>`;
                    } else {
                        bottom_links += `<li class="card-col footerpane_utility-item footer-link-text itemfont padzero"><a href="${links.href}" target="_blank"> ${links.text} </a></span></li>`;
                    }
                });

                bottom_links += `</ul ></div>`;
                $("#bottom").empty().append(bottom_links);
            }
            $("#globalFooter").empty().append(elements);
            if (subwayRegisterTradeMark !== "") {
                $("#subwayRegisterTradeMark")
                    .empty()
                    .append(
                        `<div class="copyright col-12">${subwayRegisterTradeMark[0].text}</div>`
                    );
            }

            if (isCurrentPage("cart")) {
                if (orderViewModel.currentOrder.cartQuantity == 0)
                    subwayScript.hideSpinner();
            } else subwayScript.hideSpinner();
        }
    }
}
function isCurrentPage(name) {
    if (name == "home") {
        const lang = subwayScript.navigation.getLanguageCode().toLowerCase();
        const url =  window.location.href.replace(/([?#].*)/, "").toLowerCase();
        if (
            url === window.location.origin + lang ||
            url === window.location.origin + lang + "/" ||
            url.includes("utm_campaign")
        )
            return true;
    } else if (
        name == "cart" &&
        window.location.href.indexOf("order-management") > 0
    ) {
        return true;
    } else if (
        name == "category" &&
        window.location.href.indexOf("category") > 0 &&
        window.location.href.indexOf("customizer") < 0
    ) {
        return true;
    } else if (
        name == "my-favorites" &&
        window.location.href.indexOf("my-favorites") > 0
    ) {
        return true;
    } else if (name == "menu" && window.location.href.indexOf("menu") > 0) {
        return true;
    } else if (
        name == "confirmation" &&
        window.location.href.indexOf("order-confirmation") > 0
    ) {
        return true;
    } else if (
        name == "requestmissingtokens" &&
        window.location.href.indexOf("requestmissingtokens") > 0
    ) {
        return true;
    } else if (
        name == "miam" &&
        (window.location.href.indexOf("referrer=AddToBag") > 0 ||
            window.location.href.indexOf("referrer=order-management") > 0)
    ) {
        return true;
    } else if (
        name == "customizer" &&
        window.location.href.indexOf("customizer") > 0
    ) {
        return true;
    } else if (
        name == "locator" &&
        window.location.href.indexOf("locator") > 0
    ) {
        return true;
    } else if (
        name == "deliverylocator" &&
        window.location.href.indexOf("deliverylocator") > 0
    ) {
        return true;
    } else if (
        name == "profile" &&
        (window.location.href.toLowerCase().indexOf("profile") > 0 &&
            window.location.href.toLowerCase().indexOf("profile/") === -1)
    ) {
        return true;
    } else if (
        name == "recent-orders" &&
        window.location.href.toLowerCase().indexOf("recent-orders") > 0
    ) {
        return true;
    }
    return false;
}

$(function () {
    if (window.location.href.toLowerCase().indexOf("catering") > -1) {
        $('.component_footer .horizontal_footer .start_order').hide();
    }
});

$(function () {
    var storeId = window.orderViewModel.store.id;

    compNavLocation.Bind();

    if (storeId !== null) {
        var menuHref = $(".icon-sub-combo").closest("a").attr("href");
        var url = subwayScript.navigation.getMenuUrl(storeId);
        $('a[href="' + menuHref + '"].none').text(
            orderViewModel.topNav.newDisplayText || "Menu"
        );
        $('a[href="' + menuHref + '"].none').attr("href", url);
        $('a[href="' + menuHref + '"].icon-link').attr("href", url);
    }
});

$(".check-it-btn").on("click", function () {
    var storeId = orderViewModel.store.id;
    if (storeId) {
        window.location.href = subwayScript.navigation.getMenuUrl(storeId);
    } else {
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }
});

$(document).on("click", ".hamburger, #changeLangText", function (e) {
    $(".hamburger").toggleClass("change");
    $("#overlayNav").toggleClass("overlay-mobile");
    $(".mobile-header .navbar-locator-component").toggleClass("hide-cart-icon");
    $(".navbar-locater.display-mobile").toggleClass("hide-box-shadow");

    if ($(".hamburger").hasClass("change")) {
        if ($(window).width() < 1024) {
            $("body").css("overflow-y", "hidden");
            $("html").css("overflow-y", "hidden");
            if (orderViewModel.isCountryChanged) {
                $(".navbar-main .change-language-banner").hide();
                if (e.target.className === "change-lang-text") {
                    $(".selected-language").trigger("click");
                }
            }
        }
        $(".navbar-locater .nav-links").hide();
        $(".navbar-locater .start-order-btn").hide();

        analytics.cardListClick("expanded");
    } else {
        if ($(window).width() < 1024) {
            $("body").css("overflow-y", "auto");
            $("html").css("overflow-y", "auto");
            if (orderViewModel.isCountryChanged) {
                $(".navbar-main .change-language-banner").show();
            }
        }
        $(".navbar-locater .nav-links").show();
        if ($(".banner-tile").length > 0) {
            $(".navbar-locater .start-order-btn").show();
        }

        analytics.cardListClick("closed");
    }
});
$(document).on("click", ".selected-language", function () {
    $("#language-btn").val(1);
});

$(document).on("click", ".back-link", function () {
    $(".menu-container").show();
    $(".mobile-lang-dropdown").hide();
    $(".mobile-lang-dropdown .sub-menu").css("left", "unset");
    $(".display-mobile .menu-item.menu-item-has-children").removeClass(
        "is-expanded"
    );
});

$(".nav-rest-link,.find-locator,.find-locator-mobile,.change-restaurant").click(
    function () {
        changeLocationLink();
    }
);
function changeLocationLink() {
    if (
        orderViewModel.store.id != null &&
        orderViewModel.currentOrder.cartQuantity != 0
    ) {
        modalShowId("#change-store");
        return false;
    } else {
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }
}

$("#btnChangeStore").click(function () {
    subwayScript.showSpinner();
    orderViewModel.flushCart();
    window.location.href = subwayScript.navigation.getLocatorUrl();
    return false;
});

$(".js-top-signup, .js-top-logout, .btn-order, #locator-text").on(
    "click",
    function () {
        subwayScript.showSpinner();
    }
);

$(".btn-order").on("click", function () {
    analytics.startOrContinueOrder();
    var storeId = orderViewModel.store.id;
    var buttonText = $(this).text();
    analytics.orderType(buttonText);
    orderViewModel.Analytics.orderType = buttonText;
    orderViewModel.save();
    orderViewModel.hasDeliveryLocator = false;
    orderViewModel.save();
    if (storeId !== null) {
        window.location.href = subwayScript.navigation.getMenuUrl(storeId);
    } else {
        window.location.href = subwayScript.navigation.getLocatorUrl();
    }
});

$(".delivery-locator").on("click", function () {
    var buttonText = $(this).text();
    analytics.orderType(buttonText);
    orderViewModel.Analytics.orderType = buttonText;
    orderViewModel.save();
    var deliveryUrl = subwayScript.navigation.getDeliveryLocatorUrl();
    window.location.href = deliveryUrl;
});

$(".view-menu-link").on("click", function () {
    var storeId = orderViewModel.store.id;
    window.location.href = subwayScript.navigation.getMenuUrl(storeId);
});

$(document).ready(function () {
    $(".btn").removeAttr("title");
});

hideLanguageFromDropdown();

function hideLanguageFromDropdown() {
    if (orderViewModel.store.id != null) {
        if ($('html[lang *= "US"]').length == 1) {
            $('#languageDropdown option[value *= "CA"]').detach();
            $('#languageDropdown option[value *= "PR"]').detach();
        }
        else if ($('html[lang *= "PR"]').length == 1) {
            $('#languageDropdown option[value *= "CA"]').detach();
            $('#languageDropdown option[value *= "US"]').detach();
        }
        else {
            $('#languageDropdown option[value *= "US"]').detach();
            $('#languageDropdown option[value *= "PR"]').detach();
        }
    }
}

$(".ordering-from-bar-carat").on("click keypress", function (e) {
    if (e.which === keyCodes.RETURN || e.type === "click") {
        if (
            $(this)
                .closest(".location-bar")
                .next(".expanded-content")
                .hasClass("is-collapsed")
        ) {
            $(this).addClass("is-expanded").removeClass("is-collapsed");
            $(this)
                .closest(".location-bar")
                .next(".expanded-content")
                .addClass("is-expanded")
                .removeClass("is-collapsed");
            $(this).attr("aria-expanded", true);
            $(".telephone").attr("tabindex", 0);
            $(".view-menu-link").attr("tabindex", 0);
            $(".change-restaurant").attr("tabindex", 0);
            $(this)
                .closest(".location-bar")
                .next(".expanded-content")
                .attr("aria-hidden", false);
            $(this)
                .closest(".location-bar.location-bar-overlay")
                .css("border-bottom", "none");
            if ($(window).width() > 1023) {
                $(this)
                    .closest(".location-bar.location-bar-overlay")
                    .css("height", "57px");
            }
        } else {
            $(this).addClass("is-collapsed").removeClass("is-expanded");
            $(this)
                .closest(".location-bar")
                .next(".expanded-content")
                .addClass("is-collapsed")
                .removeClass("is-expanded");
            $(this).attr("aria-expanded", false);
            $(".telephone").attr("tabindex", -1);
            $(".view-menu-link").attr("tabindex", -1);
            $(".change-restaurant").attr("tabindex", -1);
            $(this)
                .closest(".location-bar")
                .next(".expanded-content")
                .attr("aria-hidden", true);
            $(this)
                .closest(".location-bar.location-bar-overlay")
                .css("border-bottom", "1.3px solid #ececec");
            if ($(window).width() > 1023) {
                $(this)
                    .closest(".location-bar.location-bar-overlay")
                    .css("height", "75px");
            }
        }
    }
});

$(document).on("click", ".btn-order-header ,  .mobile-start-btn", function () {
    try {
        var buttonText = $(this).text().trim();
        Number(orderViewModel.currentOrder.cartQuantity) > 0
            ? analytics.startOrder(0, buttonText)
            : analytics.startOrder(1, buttonText);
    } catch (err) {
        void 0;
    }
});

/*For Analytics, To send click information to analytics.js*/
function sendClickInfoToAnalytics(linkName, sourceName, event=null) {
    if(event){
        const modalValue = event.target.getAttribute("data-model");
        event && setExternalLinkModalData(event, modalValue)
    }
    analytics.cardListClick(linkName, sourceName);
}

//My account clicks
function clickInfoToAnalytics(linkName) {
    analytics.somethingDifferentClick(linkName);
}

function changeLanguage(value) {
    const currentLangCode = subwayScript.navigation.getLanguageCode().toLowerCase();
    const linkName = $('#languageDropdown').find(":selected").text();
    if (currentLangCode) {
        if (orderViewModel.store.id) {
            const lang = value.split('-')[0].toLowerCase();
            if (lang == 'es') {
                orderViewModel.store.languageCode = 'esp';
            } else {
                orderViewModel.store.languageCode = 'eng'
            }
            orderViewModel.save();
        }

        const currentUrl = window.location.href.toLowerCase();
        analytics.cardListClick(linkName, "footer:");
        window.location.href = currentUrl.replace(currentLangCode, '/' + value.toLowerCase());
    }
}

function humbuggerClick() {
    document.body.classList.toggle('openHumbugger');
    let hamburgerButton = document.querySelector('.navbar_left_button');
    if (!($('button').hasClass('close_icon'))) {
        hamburgerButton.classList.add('close_icon');
        $('.navbar_left_button:after').css('display', 'none');
        $('.close_icon:after').css('display', 'block');
        $('.navbar.cms').css('height', '72px');
        if ($('#menuNavigation').length > 0) {
            $('#menuNavigation')[0].innerHTML = 'Close';
        }
        $('#homePageNew').attr('aria-hidden', 'true');
        $('.component_footer').attr('aria-hidden', 'true');
        $('#defaultStoreHeader').attr('aria-hidden', 'true');
        $('#aria_Live').attr('aria-hidden', 'true');
        $('#scroll_to_top').attr('aria-hidden', 'true');
        $('.body_container').attr('aria-hidden', 'true');
        trapFocus();
    }
    else {
        hamburgerButton.classList.remove('close_icon');
        $('.navbar.cms').css('height', 'auto');
        if ($('#menuNavigation').length > 0) {
            $('#menuNavigation')[0].innerHTML = 'Toggle navigation Menu';
        }
        $('#homePageNew').attr('aria-hidden', 'false');
        $('.component_footer').attr('aria-hidden', 'false');
        $('#defaultStoreHeader').attr('aria-hidden', 'false');
        $('#aria_Live').attr('aria-hidden', 'false');
        $('#scroll_to_top').attr('aria-hidden', 'false');
        $('.body_container').attr('aria-hidden', 'false');
    }
    if ($(".navbar_left_button").attr('aria-expanded') === 'false') {
        $(".navbar_left_button").attr('aria-expanded', 'true');
        $(".navbar_left_button").attr('aria-label', 'close');
    } else {
        $(".navbar_left_button").attr('aria-expanded', 'false');
        $(".navbar_left_button").attr('aria-label', 'menuNavigation');
    }
}
function trapFocus() {
    let menuContainer = document.querySelector('.navbar_left');
    const focusableElements = menuContainer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    function handleKeyDown(event) {
        if (event.key === 'Tab' || e.keyCode === 9) {
            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    }
    menuContainer.addEventListener('keydown', handleKeyDown);
    focusableElements[0].focus();
}


$(document).ready(function () {

    if (/Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        $("html").addClass("isTouch");
    }
    //TODO : need to refactor it locater
    if (orderViewModel.currentOrder && orderViewModel.currentOrder.cartQuantity
        && orderViewModel.currentOrder.cartQuantity > 0) {
        const viewBagText = $("#orderType").attr('data-continue-order-text');
        $("#orderType").text(viewBagText);
        let orderManagementURL = subwayScript.navigation.getLanguageCode() + "/orders/order-management"
        $(".component_footer .horizontal_footer .start_order button").click(function (event) { engageApptentiveEvent('View bag', true, orderManagementURL, '', event) })
    } else if (orderViewModel.store.id) {
        let menuURL = subwayScript.navigation.getLanguageCode() +
            "/restaurant/" +
            subwayScript.checkSatelliteNumber(orderViewModel.store.id) +
            "/menu"
        $(".component_footer .horizontal_footer .start_order button").click(function (event) { engageApptentiveEvent('Start Order', true, menuURL, '', event) })

    } else if (!orderViewModel.storeStatus && orderViewModel.calledCreateCart) {
        $("div.start_order > #orderType").on('click', () => (modalShowId('#modal-store-closed')));
        $("div.start_order > #orderType").removeAttr('href')
        $("div.start_order > #orderType").removeAttr('onclick')
    } else {
        var startOrderUrl = $("#hdnStartOrder").val();
        $(".component_footer .horizontal_footer .start_order button").click(function (event) { engageApptentiveEvent('Start Order', true, startOrderUrl, '', event) })
    }


    //TODO END
    if ($("body").hasClass("cms")) {
        var cmsMarginTop = $('.cms .navbar.cms').innerHeight() + $('.cms .defaultStoreHeader').innerHeight();
        $('.cms .nav_padding').css({ "padding-top": `${cmsMarginTop}px` });
        $('.cms .defaultStoreHeader').css({ "top": `${$('.cms .navbar.cms').innerHeight()}px` });
    }
    var $startOrder = $('.navbar_right .button');
    $startOrder.text($startOrder.data('title'));
    var $startOrder = $('.navbar_right .button');
    $startOrder.text($startOrder.data('title'));


    subwayScript.hideSpinner();
    setTimeout(function () {
        var marginTop = $('.navbar.cms').innerHeight() + $('.defaultStoreHeader').innerHeight();
        ;
        $('.body-top-margin').css({ "margin-top": `${marginTop}px` });
        if ($("body").hasClass("cms")) {
            var cmsMarginTop = $('.cms .navbar.cms').innerHeight() + $('.cms .defaultStoreHeader').innerHeight();
            $('.cms .nav_padding').css({ "padding-top": `${cmsMarginTop}px` });
            $('.cms .defaultStoreHeader').css({ "top": `${$('.cms .navbar.cms').innerHeight()}px` });
        }
        //window.scrollTo(0, 0);
    }, 1000);

    if (isCurrentPage('home') || isCurrentPage('profile')) {
        $('#orderType').parent().removeClass('d-none');
    }
    // Set TierLevel on all pages
    if (orderViewModel.Analytics.tierLevel) {
        if (orderViewModel.hasLoggedIn) {
            analytics.setTierLevel(orderViewModel.Analytics.tierLevel)
        }
        else {
            orderViewModel.Analytics.tierLevel = 'n/a';
            window.orderViewModel.save();
            analytics.setTierLevel('n/a')
        }

    }
    let navbarHeight = document.querySelector('.navbar') ? document.querySelector('.navbar').offsetHeight : 0;
    $(".nav_padding").css({ "padding-top": `${navbarHeight}px` });
    let defaultHeightHeight = document.querySelector('.defaultStoreHeader') ? document.querySelector('.defaultStoreHeader').offsetHeight : 0;
    const homepageHeaderHeight = navbarHeight + defaultHeightHeight;
    if (isCurrentPage('home')) {
        $("#homePageNew").css({ "margin-top": `${homepageHeaderHeight}px` });
    }
    $(".center_layout,  .rail").css({ "padding-top": `${homepageHeaderHeight}px`});
    subwayScript.setCookie('CartId', orderViewModel.currentOrder.cartId, 90);
});

$(window).bind("pageshow", function (event) {
    void 0;
    if (event.originalEvent.persisted) {
        void 0;
        window.location.reload();
    }
});

function disableInteractiveElements() {
    const $body = $('body'); 
    const isDisabled = $body.hasClass('disableInteraction');

    if (isDisabled) {
        $body.removeClass('disableInteraction');
        $(document).off('touchstart touchmove touchend', '.disableInteraction', preventDefault);
    } else {
        $body.addClass('disableInteraction');
        $(document).on('touchstart touchmove touchend', '.disableInteraction', preventDefault, { passive: false });
    }

    updateDynamicElements(isDisabled);
}

function preventDefault(e) {
    e.preventDefault();
}

function updateDynamicElements(isDisabled) {
    const $elements = $('.cursor-pointer, .modal-content'); //add more elements if needed
    
    if (isDisabled) {
        $elements.removeClass('disableInteraction');
    } else {
        $elements.addClass('disableInteraction');
    }
}
